if (!customElements.get('endless-collection')) {
  class EndlessCollection extends HTMLElement {
    selectors = {
      loadMoreButton: '[data-load-more]',
      loadMoreContainer: '[data-load-more-container]',
      collectionItems: '[data-collection-items]',
      sentinel: '[data-load-more-sentinel]'
    };
    parser = new DOMParser();
    observer = undefined;
    sentinel = this.querySelector(this.selectors.sentinel);

    constructor() {
      super();

      if (this.hasAttribute('data-endless-load')) {
        this.initEndlessLoad();
      }

      this.addEventListener('click', this.handleClick.bind(this));
    }

    /**
     * Click event handler.
     *
     * @param {Event} event
     * @returns {void}
     */
    async handleClick(event) {
      if (!event.target.closest('[data-load-more]')) return;
      event.preventDefault();

      this.loadNextPage();
    }

    /**
     * Loads the next page of products.
     */
    async loadNextPage() {
      const nextUrl = this.querySelector(
        this.selectors.loadMoreButton
      ).getAttribute('href');
      const { productCards, button } = await this.getNextPageMarkup(
        nextUrl
      );
      const currentButton = this.querySelector(
        this.selectors.loadMoreButton
      );

      for (const product of productCards) {
        this.querySelector(
          this.selectors.collectionItems
        )?.appendChild(product);
      }

      if (button && button.getAttribute('href')) {
        currentButton.replaceWith(button);
      } else {
        this.querySelector(this.selectors.loadMoreContainer).remove();
      }

      if (this.observer) {
        this.observer.observe(this.sentinel);
      }
    }

    /**
     * Gets product cards from an URL.
     *
     * @param {String} url
     * @returns {Object} - { productCards: NodeList, button: Node }
     */
    async getNextPageMarkup(url) {
      const response = await fetch(url);
      const data = await response.text();
      const html = this.parser.parseFromString(data, 'text/html');
      return {
        productCards:
          html.documentElement.querySelectorAll('card-product'),
        button: html.documentElement.querySelector(
          this.selectors.loadMoreButton
        )
      };
    }

    /**
     * Initializes the endless load functionality.
     */
initEndlessLoad() {
  this.observer = new IntersectionObserver(entries => {
    entries.forEach(
      entry => {
        if (entry.isIntersecting) {
          this.querySelector(
            this.selectors.loadMoreButton
          )?.click();
          this.observer.unobserve(entry.target);
        }
      },
      {
        threshold: 1
      }
    );
  });

  this.observer.observe(this.sentinel);
}
  }
  customElements.define('endless-collection', EndlessCollection);
}
